import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import axios from 'axios';

axios.defaults.baseURL = 'http://hotel-demo.progmasters.hu:8090';
// axios.defaults.baseURL = 'http://localhost:8080';
axios.defaults.withCredentials = true;
if(JSON.parse(localStorage.getItem('user')) === null || JSON.parse(localStorage.getItem('user'))=== undefined ){
    const anonymUser = {
        name: "anonym",
        role: "ROLE_ANONYMOUS"
    }
    localStorage.setItem('user', JSON.stringify(anonymUser));
}
ReactDOM.render(<App/>, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js